import "core-js/modules/es.array.push.js";
import cookies from 'vue-cookies';
import axios from 'axios';
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      password: '',
      writtenPass: '',
      bingWallPaperIndex: 0,
      customWallPaperIndex: 0
    };
  },
  computed: {
    ...mapGetters(['userConfig', 'bingWallPapers']),
    bkInterval() {
      return this.userConfig?.bkInterval || 3000;
    },
    bkOpacity() {
      return this.userConfig?.bkOpacity || 1;
    }
  },
  mounted() {
    const bg1 = document.getElementById('bg1');
    const bg2 = document.getElementById('bg2');
    if (this.userConfig?.loginBkImg === 'bing') {
      //bing壁纸轮播
      this.$store.dispatch('fetchBingWallPapers').then(() => {
        bg1.src = this.bingWallPapers[this.bingWallPaperIndex]?.url;
        bg1.onload = () => {
          bg1.style.opacity = this.bkOpacity;
        };
        setInterval(() => {
          let curBg = bg1.style.opacity != 0 ? bg1 : bg2;
          let nextBg = bg1.style.opacity != 0 ? bg2 : bg1;
          curBg.style.opacity = 0;
          this.bingWallPaperIndex = (this.bingWallPaperIndex + 1) % this.bingWallPapers.length;
          nextBg.src = this.bingWallPapers[this.bingWallPaperIndex]?.url;
          nextBg.onload = () => {
            nextBg.style.opacity = this.bkOpacity;
          };
        }, this.bkInterval);
      });
    } else if (this.userConfig?.loginBkImg instanceof Array && this.userConfig?.loginBkImg?.length > 1) {
      //自定义壁纸组轮播
      bg1.src = this.userConfig.loginBkImg[this.customWallPaperIndex];
      bg1.onload = () => {
        bg1.style.opacity = this.bkOpacity;
      };
      setInterval(() => {
        let curBg = bg1.style.opacity != 0 ? bg1 : bg2;
        let nextBg = bg1.style.opacity != 0 ? bg2 : bg1;
        curBg.style.opacity = 0;
        this.customWallPaperIndex = (this.customWallPaperIndex + 1) % this.userConfig.loginBkImg.length;
        nextBg.src = this.userConfig.loginBkImg[this.customWallPaperIndex];
        nextBg.onload = () => {
          nextBg.style.opacity = this.bkOpacity;
        };
      }, this.bkInterval);
    } else if (this.userConfig?.loginBkImg instanceof Array && this.userConfig?.loginBkImg?.length == 1) {
      //单张自定义壁纸
      bg1.src = this.userConfig.loginBkImg[0];
      bg1.onload = () => {
        bg1.style.opacity = this.bkOpacity;
      };
    } else {
      //默认壁纸
      bg1.src = require('@/assets/background.jpg');
      bg1.onload = () => {
        bg1.style.opacity = this.bkOpacity;
      };
    }
  },
  methods: {
    login() {
      // set authCode to Cookie, expires in 2 weeks
      if (this.password === '') {
        this.writtenPass = 'unset';
      } else {
        this.writtenPass = this.password;
      }
      axios.post('/login', {
        authCode: this.password
      }).then(res => {
        if (res.status !== 200) {
          this.$message.error('登录失败，请检查认证码是否正确~');
          return;
        }
        cookies.set('authCode', this.writtenPass, '14d');
        this.$router.push('/');
        this.$message.success('登录成功~');
      }).catch(err => {
        this.$message.error('登录失败，请检查认证码是否正确~');
      });
    }
  }
};